import {GetterTree} from 'vuex'
import {RootState} from '@/store'
import {AuthorizationState} from '@/store/modules/authorization/index'

export const getters: GetterTree<AuthorizationState, RootState> = {

    accessToken(state): string {
        return state.accessToken
    },

    refreshToken(state): string {
        return state.refreshToken
    }
}